exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.BlockPaginAnchor[data-v-e10a7742]\n{\n    display:inline;\n    display:initial;\n}\n", ""]);

// exports
